import {defer, finalize, Observable, Subject} from 'rxjs';

/**
 * Custom operator that emits the completion state of the inner observable
 * into the given subject.
 * Emits `true` to the subject initially, and `false` when the inner observable is complete or failed.
 * Useful for busy state indicators.
 * @param indicator
 */
export function indicate<T>(indicator: Subject<boolean>): (source: Observable<T>) => Observable<T> {
	return (source: Observable<T>): Observable<T> => source.pipe(
		prepare(() => queueMicrotask(() => indicator.next(true))),
		finalize(() => queueMicrotask(() => indicator.next(false)))
	);
}

function prepare<T>(callback: () => void): (source: Observable<T>) => Observable<T> {
	return (source: Observable<T>): Observable<T> => defer(() => {
		callback();
		return source;
	});
}
